/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Widget_Icon_AlphaInputs */

const en_enum_widget_icon_alpha = /** @type {(inputs: Enum_Widget_Icon_AlphaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha`)
};

const de_enum_widget_icon_alpha = /** @type {(inputs: Enum_Widget_Icon_AlphaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha`)
};

/**
* | output |
* | --- |
* | "Alpha" |
*
* @param {Enum_Widget_Icon_AlphaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_widget_icon_alpha = /** @type {((inputs?: Enum_Widget_Icon_AlphaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Widget_Icon_AlphaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_widget_icon_alpha(inputs)
	return de_enum_widget_icon_alpha(inputs)
});